<template>
  <div class="container page">
    <van-nav-bar :title="$t('setbank.title')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="wrapper">
      <div class="add-card" @click="toBindCard()" v-if="!is_bind">
        <van-icon name="plus" />
        <span>{{ $t('setbank.bank') }}</span>
      </div>
      <div class="bank" v-else>
          <div class="info">
            <div class="row-content" v-if="false">{{$t('bindCard.financial_institution')}}：{{this.bankInfo.financial_institution}}</div>
            <div class="row-content" v-if="false">{{$t('bindCard.branch')}}：{{this.bankInfo.branch}}</div>
            <div class="row-content">{{$t('bindCard.branch_number')}}：{{this.bankInfo.branch_number}}</div>
            <div class="row-content">{{$t('bindCard.name')}}：{{this.bankInfo.bankinfo}}</div>
            <div class="row-content">{{$t('bindCard.card')}}：{{this.bankInfo.bankid}}</div>
          </div>
      </div>
      <div class="tips">{{ $t('setbank.hint') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_bind:false,
      bankInfo:{},
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          if(res.data.is_bank){
            this.is_bind = true;
            this.bankInfo = res.data.info;
          }else {
            this.is_bind = false;
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    toBindCard() {
      /*if (!this.userInfo.name) {
        this.$router.push("Setname?type=1");
        this.$toast(this.$t("msg.请设置姓名后再绑定银行卡！"));
        return true;
      }else */if(!this.userInfo.paypassword){
        this.$router.push("SetPayPassword?type=1");
        this.$toast(this.$t("msg.请设置提现密码后再绑定银行卡！"));
        return true;
      } else {
        this.$router.push({path:'/BindCard'})
      }
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 18PX;
  line-height: 40PX;
}

.container p{
  padding: 0 15PX;
  margin-top: 15PX;
  font-size: 18PX;
  color: #dc2037;
}
.manage-card .wrapper{
  height: calc(100% - 10PX);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.wrapper .add-card{
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  background-color: #fff;
  height: 125PX;
}
.wrapper .add-card span{
  margin-left: 10PX;
  font-size: 18PX;
}
.wrapper .tips {
  margin: 15PX 15PX;
  font-size: 16PX;
  color: #979799;
}
.wrapper .bank .info {
  margin-left: 20PX;
  flex: 1;
  color: #000;
}
.wrapper .bank .info .row-content{
  margin: 18PX 0;
  line-height: 20PX;
  font-size: 18PX;
}
</style>
